import React, { useEffect, useMemo, useState } from "react";
import emp1 from "../../../../assets/images/empv1.png";
import emp2 from "../../../../assets/images/empv2.png";
import emp3 from "../../../../assets/images/empv3.png";
import { getAttendanceSummary } from "../../../Apis/DashboardApis/primaryDashboardApi";
import CardLoader from "../../../Common/ShimmerLoader/CardLoader";
import DashboardSectionCard from "./shared/DashboardSectionCard";
import DashboardFilters from "./shared/DashboardFilters";
import MetricStat from "./shared/MetricStat";
import useDashboardFilters from "./shared/useDashboardFilters";

const formatCount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return Number(value).toLocaleString();
};

const formatPercentage = (value) => {
  if (value === null || value === undefined || value === "") {
    return "0%";
  }

  return `${Number(value).toFixed(2)}%`;
};

const buildStats = (summary) => [
  {
    iconSrc: emp1,
    label: "Total Employees",
    value: formatCount(summary?.totalEmployees),
    color: "#2563eb",
  },
  {
    iconSrc: emp2,
    label: "Present Employees",
    value: formatCount(summary?.presentCount),
    color: "#16a34a",
    subValue: formatPercentage(summary?.presentPercentage),
    subValueColor: "#2563eb",
  },
  {
    iconSrc: emp3,
    label: "Absent Employees",
    value: formatCount(summary?.absentCount),
    color: "#dc2626",
    subValue: formatPercentage(summary?.absentPercentage),
    subValueColor: "#2563eb",
    highlighted: true,
  },
];

const AttendanceSummary = ({ wards, data }) => {
  const {
    filters,
    appliedFilters,
    handleFilterChange,
    handleSearch,
  } = useDashboardFilters();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    if (Array.isArray(data)) {
      return undefined;
    }

    let isMounted = true;

    const fetchSummary = async () => {
      try {
        setLoading(true);
        const response = await getAttendanceSummary(appliedFilters);

        if (isMounted && response?.status) {
          setSummary(response?.data ?? null);
        }
      } catch (error) {
        console.error("Failed to load attendance summary:", error);
        if (isMounted) {
          setSummary(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSummary();

    return () => {
      isMounted = false;
    };
  }, [appliedFilters, data]);

  const stats = useMemo(() => {
    if (Array.isArray(data)) {
      return data;
    }

    return buildStats(summary);
  }, [data, summary]);

  return (
    <DashboardSectionCard
      title="Attendance Summary"
      className="pd-attendance-section"
      filters={
        <DashboardFilters
          className="pd-attendance-filters"
          fromDate={filters?.fromDate}
          toDate={filters?.toDate}
          ward={filters?.ward}
          wards={wards}
          onFromDateChange={(value) => handleFilterChange("fromDate", value)}
          onToDateChange={(value) => handleFilterChange("toDate", value)}
          onWardChange={(value) => handleFilterChange("ward", value)}
          onSearch={handleSearch}
          showSearch
        />
      }
    >
      {loading ? (
        <CardLoader count={3} />
      ) : (
        <div className="pd-metric-row cols-3 pd-attendance-row">
          {stats.map((item) => (
            <MetricStat key={item.label} {...item} boxed />
          ))}
        </div>
      )}
    </DashboardSectionCard>
  );
};

export default AttendanceSummary;
